import { BaseSurvey } from '../base-survey';
import { AssetLibraryAIGCMVPSurveyView } from './view';
import { validateAssetLibraryTriggerCondition } from '../utils';

export class AssetLibraryAIGCMVPSurvey extends BaseSurvey {
  getSurveyName = () => 'AssetLibraryAIGCMVPSurvey';

  getSurveyId = isTestEnv => (isTestEnv ? '63819467-5b7d-4902-bc32-e52b8f70fd3b' : '86295b65-c73d-4c79-962c-571635031414');

  validateTriggerCondition = () => validateAssetLibraryTriggerCondition(this, 'AssetLibraryAIGCMVPSurveyTrigger');

  onSurveySubmit() {
    window.survey.AssetLibraryAIGCMVPSurveyTrigger = false;

    super.onSurveySubmit();
  }

  onSurveyDismiss() {
    window.survey.AssetLibraryAIGCMVPSurveyTrigger = false;

    super.onSurveyDismiss();
  }

  getSurveyComponent = () => AssetLibraryAIGCMVPSurveyView;
}
